<template>
    <b-dropdown
      toggle-class="text-decoration-none"
      variant="light select-page"
      ref="dropdown"
      id="dropdown-page"
      menu-class="w-100"
      class="w-100 dropdown-page"
    >
      <template #button-content>
        <div class="d-flex justify-content-between align-items-center">
          <span class="fs-sa-14 -mb-0 page-title"> {{ getSelectedPage }} </span>
          <i class="far fa-angle-down"></i>
        </div>
      </template>
      <div id="search">
        <div style="position: relative" class="mx-15 my-2">
          <b-form-input v-model="text" :placeholder="$t('engine.modal.addlink.setting.selectPage.lblSearch', languageEngine)"></b-form-input>
          <span
            class="text-muted"
            style="position: absolute; right: 10px; top: 7px"
          >
            <i class="far fa-search"></i>
          </span>
        </div>
      </div>
      <div v-if="text !== ''" class="pb-10 px-15">
        <p class="fs-sa-14 mb-0 text-bold">Search Results({{ countSearch }})</p>
        <hr class="mt-0 mb-2" />
      </div>
      <div class="text-center" v-if="countSearch === 0">
        <p class="fs-sa-14 mb-0 text-mute">Sorry No result found.</p>
      </div>
      <div v-for="key in Object.keys(getListByType)" :key="`${key}`">
        <b-dropdown-group
          :header="`${capitalize(key)}`"
          v-if="getListByType[key][0].data > 0"
        >
          <span
            v-for="page in getListByType[key]"
            :key="`custom_${page.id}_headermenu`"
            @click="setData(page.id)"
          >
            <b-dropdown-item-button
              v-if="page.show && (mainPageID == page.id ? !isChild : page.show)"
              :active="value == page.id"
            >
              <p class="fs-sa-14 mb-0">
                {{ page.properties.name || capitalize(page.properties.type) }}
                <span v-if="!page.properties.isEnable" class="ml-3"><i class="far fa-eye-slash text-hint"></i></span>
              </p>
            </b-dropdown-item-button>
          </span>
        </b-dropdown-group>
      </div>
    </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";

export default {
  data() {
    return {
      action: "add",
      text: "",
    };
  },
  watch: {
    elActiveID: function () {
      this.$refs.dropdown.hide(true);
    },
  },
  methods: {
    capitalize,
    managePage() {
      this.action = "add";
      this.$bvModal.show("modal-add-page-header");
      this.$refs.dropdown.hide(true);
    },
    setData(id) {
      this.$emit("input", id);
    },
  },
  computed: {
    ...mapGetters({
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
    mainPageID() {
      return (
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID
      );
    },
    getListByType() {
      this.action;
      var object_list = {
        custom: [{ data: 0 }],
        system: [{ data: 0 }],
      };

      if (this.siteComponents) {
        Object.entries(JSON.parse(JSON.stringify(this.siteComponents))).forEach(([key, item]) => {
          key;
          let type = "plus";
          if (item.type === "PAGE") {
            if (
              item.properties.name &&
              item.properties.name
                .toLowerCase()
                .indexOf(this.text.toLowerCase()) > -1
            ) {
              item.show = true;
            } else if (
              item.properties.type &&
              item.properties.type
                .toLowerCase()
                .indexOf(this.text.toLowerCase()) > -1
            ) {
              item.show = true;
            } else {
              item.show = undefined;
              type = "minus";
            }
            switch (item.properties.groupType) {
              case "system":
                type === "plus" ? (object_list.system[0].data += 1) : "";
                object_list.system.push(item);
                break;
              case "custom":
                type === "plus" ? (object_list.custom[0].data += 1) : "";
                object_list.custom.push(item);
                break;
              default:
            }
          }
        });
      }
      return object_list;
    },
    countSearch() {
      return (
        this.getListByType.custom[0].data +
        this.getListByType.system[0].data
      );
    },
    getSelectedPage() {
      const pageName = (this.value &&
          this.siteComponents &&
          this.siteComponents[this.value] &&
          this.siteComponents[this.value].properties.name)

      if (pageName) {
        return this.siteComponents[this.value].properties.name;
      } else {
        this.$emit("input", null);
        return this.$t("engine.modal.addlink.setting.selectPage.lblChoosePage", this.languageEngine)
      }
     
    },
  },
  props: {
    value: {
      required: true,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
#search {
  position: sticky;
  background-color: white;
  height: 50px;
  top: -8px;
  padding-top: 1px;
  box-shadow: 0 4px 15px -1px white;
}
#dropdown-page .dropdown-header {
  min-width: 15rem;
  padding: 6px 20px;
  margin-bottom: 0;
  font-family: "Sarabun";
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  color: #84929f;
  background-color: #f8f9fa;
  white-space: nowrap;
}

#dropdown-page .dropdown-menu {
  max-height: 70vh;
  overflow-y: auto;
}

#dropdown-page .dropdown-item.active, 
#dropdown-page .dropdown-item:active { color: #24BEE2 !important; background-color: #FFFFFF !important; }
#dropdown-page .dropdown-item:hover {
  background-color: #f4fcff !important;
}
</style>
